import React from 'react'
import { Form as FinalForm, Field } from 'react-final-form'
import { Form, Input } from 'semantic-ui-react'

export const ProductSearch = ({ setProductId }: { setProductId: (value: string) => void }) => (
  <FinalForm
    initialValues={{ lookupId: '' }}
    onSubmit={(values) => {
      setProductId(values.lookupId)
    }}
    render={(props) => (
      <Form onSubmit={props.handleSubmit}>
        <Field
          name="lookupId"
          render={({ input }) => (
            <Form.Field inline style={{ display: 'flex', alignItems: 'center' }}>
              <label
                style={{
                  fontSize: '1.71428571em',
                  fontWeight: 600,
                  lineHeight: '1.28571429em',
                }}
                htmlFor={input.name}
              >
                Product ID:{' '}
              </label>
              <Input action="Search" placeholder="Product Id" {...input} />
            </Form.Field>
          )}
        />
      </Form>
    )}
  ></FinalForm>
)
